import { useNavigate } from 'react-router-dom'

import { Button } from '@paysense-india-services/elevate-web'

import CardComponent from '@/components/CardComponent/index'
import Section from '@/components/Section/index'

const UpcomingRepaymentCard = ({ data }) => {
  const navigate = useNavigate()
  const handlePayClick = url => {
    if (url) {
      navigate(url)
    }
  }

  return (
    <Section title={data?.title}>
      {data?.components?.items?.map(component => (
        <CardComponent
          footer={
            component?.actions?.default?.text ? (
              <Button
                className='ew-bg-primary ew-color-brand ew-w-100 ew-mt-8'
                onClick={() => handlePayClick(component?.actions?.default?.url)}
                size='medium'>
                {component?.actions?.default?.text}
              </Button>
            ) : null
          }
          key={component?.type}>
          <div className='ew-typography-large'>{component?.title}</div>
          <div className='ew-typography-small ew-fw-regular ew-color-secondary'>
            {component?.subtitle}
          </div>
        </CardComponent>
      ))}
    </Section>
  )
}

export default UpcomingRepaymentCard
